import React from 'react';
import styled from 'styled-components';
import { black } from 'core/styles';

const ModalContent = styled.div`
  position: absolute;
  display: flex;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  opacity: ${({ isOpen }) => (isOpen ? 0.86 : 0)};
  z-index: ${({ isOpen }) => (isOpen ? 0 : -1)};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const OverLay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: ${black};
  opacity: ${({ isOpen }) => (isOpen ? 0.86 : 0)};
  z-index: ${({ isOpen }) => (isOpen ? 0 : -1)};
  transition: all 80ms linear 50ms;
`;

const Modal = ({ children, isOpen, close }) => {
  return (
    <>
      <OverLay onClick={close} isOpen={isOpen} />
      <ModalContent isOpen={isOpen}>{isOpen && children}</ModalContent>
    </>
  );
};
export default Modal;
